import { DateUtils } from '@cuatroochenta/co-admin-react-library'
import { CustomResponse } from '../model/data/common'
import TaskBase from './TaskBase'
import Urls from './Urls'
import { Center } from '../model/domain/center'
import { UserAudit, AuditType } from '../model/domain/audit'

export default class TaskAudit extends TaskBase {
    public getAudits(
        startDate: Date,
        endDate: Date,
        type: AuditType,
        centerId?: Center['id'] | null,
        email?: string
    ): Promise<UserAudit[]> {
        const formattedStartDate = DateUtils.formatDateForQueryString(startDate)
        const formattedEndDate = DateUtils.formatDateForQueryString(endDate)

        let url = `${Urls.URL_GET_AUDIT}?start_date=${formattedStartDate}&end_date=${formattedEndDate}&type=${type}`
        
        if (centerId) {
            url += `&center_id=${centerId}`
        }

        if (email) {
            url += `&email=${encodeURIComponent(email)}`
        }

        return fetch(url, this.getRequestInfo())
            .then((response) => response.json())
            .then((response: CustomResponse<UserAudit[]>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error fetching audits:', error)
                throw error
            })
    }
}
